import { render, staticRenderFns } from "./WorkLoadConfirmRegister.vue?vue&type=template&id=466735fd"
import script from "./WorkLoadConfirmRegister.vue?vue&type=script&lang=js"
export * from "./WorkLoadConfirmRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('466735fd')) {
      api.createRecord('466735fd', component.options)
    } else {
      api.reload('466735fd', component.options)
    }
    module.hot.accept("./WorkLoadConfirmRegister.vue?vue&type=template&id=466735fd", function () {
      api.rerender('466735fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/WorkLoadConfirmRegister.vue"
export default component.exports